import { render } from "./dbsync.vue?vue&type=template&id=6aaa3ec8"
import script from "./dbsync.vue?vue&type=script&lang=js"
export * from "./dbsync.vue?vue&type=script&lang=js"

import exportComponent from "/opt/tooltip_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QSelect});
